import { ObservationSummaryDto } from '../../coaching-base/general';
import { ModelTransformer } from '../../common/common.model';

import { ObservationSummaryDtoTransformer } from './observation-summary-dto.transformer';

export class ObservationSummaryDtoSetTransformer
    implements
        ModelTransformer<ObservationSummaryDto[], ObservationSummaryDto[]>
{
    transform(model: ObservationSummaryDto[]): ObservationSummaryDto[] {
        const transformer = new ObservationSummaryDtoTransformer();
        return model.map((e) => transformer.transform(e));
    }
}
